import { Injectable } from '@angular/core';
import {Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
  providedIn: 'root'
})
export class RoutesService {
  constructor(private http: HttpClient) {}

  /**
   * consulta para obtener las tarifas por rutas
   */
  getFares(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/routes/getfares`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para obtener los permisos
   */
  addFee(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/routes/create`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para eliminar un registro
   */
  deleteFee(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/routes/delete`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para obtener las categorías
   */
  getCategories(): Observable<any>{
    const body = JSON.stringify({});
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/routes/getcategories`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Función para mostrar o remover loading
   */
  controlLoader(show:boolean):void{
    // let elemet: any = document.getElementsByClassName("loader-screen")[0];
    // elemet.style.opacity = 0.8;
    // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
  }


}
